import './App.css';
import './Admin.css';
import './blueButtons.css';
import './draggableModals.css';
import Routing from './Routing';
import { GoogleOAuthProvider } from '@react-oauth/google';
import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { enableAxisLockScroll } from './Utils/axisLockScroll';
import { enableDraggableModals } from './Utils/draggableModals';
import InstallPrompt from './Components/PWA/InstallPrompt';
import EnableBadgePrompt from './Components/PWA/EnableBadgePrompt';

const clientId = '319571023204-dr9kca64rv9addd686gpghfip8754o3a.apps.googleusercontent.com';
Modal.setAppElement("#root");
function App() {

  // Lists that scroll both ways follow the finger diagonally otherwise
  useEffect(() => enableAxisLockScroll(), []);

  // Every modal can be dragged out of the way to read what is behind it
  useEffect(() => enableDraggableModals(), []);

  return (
    <div>
      <GoogleOAuthProvider clientId={clientId}>
        <Routing />
      </GoogleOAuthProvider>
      {/* Mobile-only "add to home screen" sheet; renders nothing elsewhere */}
      <InstallPrompt />
      {/* Only inside the installed app, and only where the badge needs a permission */}
      <EnableBadgePrompt />
    </div>
  );
}

export default App;